<!-- 导入退件单号 -->
<template>
<div>
  <el-dialog title="导入退件单号" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        :lose-on-press-escape="false"
        width="400"
    >
    <div class="content-panel">
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="18">
                <el-button size="mini"
                    @click="doSelectFile()" type="success" 
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="iconfont icon-xuanzewenjian" 
                            style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                        </transition>
                </el-button>
                <div ref="fileArea" style="display:none;">
                </div>
            </el-col>
            <el-col :sm="24" :md="6">
                <el-button type="primary" size="mini" @click="doDownloadInventoryTpl" plain style="margin-bottom:5px;">
                    <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                    <transition name="el-fade-in-linear">
                        <span v-show="!isMinScreen">{{msg('下载模板')}}</span>
                    </transition>
                </el-button>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results"  max-height="400" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="code" :label="msg('库存编号')" min-width="120" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="backCode" :label="msg('退件单号')" min-width="120" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="result" :label="msg('上传结果')" min-width="200" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</el-dialog>
</div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'StockImport',
    components: {},
    data(){
        return {
            excelHeads: [], //从excel解析出数据的表头
            excelData: null, //从excel解析出的数据
            colNames: [],
            results:[],
            visible:false,
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    mounted(){
    },
    methods:{
        show(){
            this.visible = true;
            this.results = [];
        },
        doSelectFile(){  //点击选择文件
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            var _this = this;
            input.onchange=this.getUploadFile;    
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {  //解析上传的excel
            let that = this;
            this.excelData = null
            this.excelName = null
            //拿到所导入文件的名字
            let fileName = e.target.files[0];
            //定义reader，存放文件读取方法
            let reader = new FileReader();
            //启动函数
            reader.readAsBinaryString(fileName)
            //onload在文件被读取时自动触发
            reader.onload = (e) => {
                //workbook存放excel的所有基本信息
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                let sheetList = workbook.SheetNames
                //存放json数组格式的表格数据
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                that.excelData = json.splice(0);
                that.excelName = fileName.name;
                that.excelHeads = heads;
                that.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        doDownloadInventoryTpl(){
            var titles = [['库存编号','退件单号','退件费用'],
            [],[],[],
            ['(导入时说明内容必须删除)']];
 
            var filename = '退件单号模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doUpload(){

            if(!this.excelData || this.excelData.length == 0){
                this.$message(this.msg('请上传一个内容不为空的excel文件'));
                return;
            }

            let ok = true;
            let msg = null;
            this.excelData.forEach(e => {
                if(!e[0]){
                    msg = '库存编号不能为空，请检查数据';
                    ok = false;
                    return;
                }
            })
            if(!ok){
                this.$message(msg);
                return;
            }

            this.$axios.post(this.$kit.api.inventory.doImportBackCode, 
                this.excelData)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        this.results = data;
                    }else{
                        this.$message(result.msg || this.msg('数据错误，请检查表格数据'));
                    }
                });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>